import type { AuthUser, TokenPayload } from "./types";
import { REFRESH_TOKEN_STORAGE_KEY, TOKEN_STORAGE_KEY } from "./config";

export function loadToken(): string | null {
  return sessionStorage.getItem(TOKEN_STORAGE_KEY);
}

export function storeToken(token: string): void {
  sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
}

export function clearToken(): void {
  sessionStorage.removeItem(TOKEN_STORAGE_KEY);
}

export function loadRefreshToken(): string | null {
  return sessionStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
}

export function storeRefreshToken(token: string): void {
  sessionStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, token);
}

export function clearRefreshToken(): void {
  sessionStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
}

export function decodePayload(token: string): TokenPayload | null {
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  try {
    const payloadPart = parts[1] ?? "";
    const padded = payloadPart + "===".slice((payloadPart.length + 3) % 4);
    // atob 产出 Latin-1 字符串;payload 里的 UTF-8 字节(中文显示名,
    // 如「林晓芸」)会变成 "æ æ è" 乱码。按字节还原后用 TextDecoder
    // 正确解码(华予 demosite 2026-08-14 实测)。
    const binary = atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
    const bytes = Uint8Array.from(binary, (ch) => ch.charCodeAt(0));
    const json = new TextDecoder("utf-8").decode(bytes);
    return JSON.parse(json) as TokenPayload;
  } catch {
    return null;
  }
}

export function isExpired(payload: TokenPayload | null, skewSeconds = 30): boolean {
  if (!payload?.exp) return false;
  return payload.exp * 1000 < Date.now() + skewSeconds * 1000;
}

export function toUser(payload: TokenPayload): AuthUser {
  return {
    id: payload.sub,
    email: payload.email,
    name: payload.name ?? payload.email,
    role: payload.role,
    isPlatformAdmin: payload.is_platform_admin === true,
    isAdmin: payload.role === "admin" || payload.role === "platform_admin",
  };
}
